export default __webpack_public_path__ + "static/media/justin-bober.579afced.svg";